import { Flex } from '@aloft/toolkit-sui';

import { CSSProperties } from 'react';

import { SimpleImage } from '../../../components/SimpleImage.tsx';

const imageStyle = {
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  maxWidth: undefined,
  maxHeight: undefined,
} as CSSProperties;

export const MLSDataImages = ({ media }: { media?: { MediaURL: string }[] }) => {
  if (!media || media.length === 0) {
    return null;
  }

  return (
    <Flex marginTop="5px" width="100%" aspectRatio="2">
      <Flex flex={3} height="100%">
        <SimpleImage url={media[0]?.MediaURL ?? ''} style={imageStyle} />
      </Flex>
      {media.length > 1 && (
        <Flex
          flexDirection="column"
          justifyContent="space-evenly"
          flex={1}
          height="100%"
          marginLeft="10px"
          gap="10px"
        >
          <Flex height="calc(33.33% - 6.67px)">
            <SimpleImage url={media[1]?.MediaURL ?? ''} style={imageStyle} />
          </Flex>
          <Flex height="calc(33.33% - 6.67px)">
            <SimpleImage url={media[2]?.MediaURL ?? ''} style={imageStyle} />
          </Flex>
          <Flex height="calc(33.33% - 6.67px)">
            <SimpleImage url={media[3]?.MediaURL ?? ''} style={imageStyle} />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
